import { useNavigate } from "@tanstack/react-router";
import { X } from "lucide-react";

const FilterNotFoundBanner = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const navigate = useNavigate() as any;

  return (
    <div className="mx-4 mt-2 mb-0 px-4 py-3 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg flex items-center justify-between animate-content-fade">
      <span className="text-amber-800 dark:text-amber-200 text-sm">
        The selected filter no longer exists.
      </span>
      <button
        onClick={() => navigate({ search: () => ({}), replace: true })}
        className="text-amber-600 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-200 p-1"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default FilterNotFoundBanner;
